var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.menubar)?_c('home-system-bar'):_vm._e(),(_vm.menubar)?_c('home-app-bar'):_vm._e(),(_vm.menubar === false)?_c('home-back-bar'):_vm._e(),_c('home-view'),_c('home-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }